import { render, staticRenderFns } from "./autocomplete2.vue?vue&type=template&id=2e2c97cd&"
import script from "./autocomplete2.vue?vue&type=script&lang=js&"
export * from "./autocomplete2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports